import React, { useState } from "react";
import {IntlMessageValue, MIcon} from "../../../../../@WUM/core/Elements";
import Avatar from "@material-ui/core/Avatar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


const StatusBar = () => {

    const user = localStorage.getItem('username');
    const today = new Date();
    const formatted = today.toLocaleDateString('de-DE');

    let avatar = ""

    if (user?.includes(' ')) {
        avatar =
            user.split(' ')[0].charAt(0).toUpperCase() +
            '' +
            user.split(' ')[1].charAt(0).toUpperCase()
    } else {
        avatar = user?.split(' ')[0].charAt(0).toUpperCase() || ""
    }

    return (
        <Row>
            <Col className={"d-flex align-items-center gap-2"}>
                <Avatar style={{float: 'left'}}
                        src={'data:image/png;base64,' + localStorage.getItem('avatar') as string}>
                    {avatar}
                </Avatar> {user}
            </Col>
            <Col className={"d-flex align-items-center gap-2 justify-content-end"}>
                <MIcon children={"calendar_today"} />{formatted}
            </Col>

        </Row>
    );
};

export default StatusBar;
